import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=55fdd5d5&scoped=true&"
import script from "./EditQuote.vue?vue&type=script&lang=js&"
export * from "./EditQuote.vue?vue&type=script&lang=js&"
import style0 from "./EditQuote.vue?vue&type=style&index=0&id=55fdd5d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdd5d5",
  null
  
)

export default component.exports